import { useState } from 'react';
import { useMutation, useQuery } from '@tanstack/react-query';
import { searchAPI } from '../services/api';
import type { SearchRequest, CandidateMatch } from '../shared/types';

export function useSearch() {
  const [searchResults, setSearchResults] = useState<CandidateMatch[]>([]);
  const [searchTime, setSearchTime] = useState<number>(0);

  const searchMutation = useMutation({
    mutationFn: (searchRequest: SearchRequest) => {
      console.log('Making search API call with:', searchRequest);
      return searchAPI.searchCandidates(searchRequest);
    },
    onSuccess: (response) => {
      console.log('Search API response:', response);
      if (response.success && response.data) {
        setSearchResults(response.data.matches);
        setSearchTime(response.data.searchTime);
      }
    },
    onError: (error) => {
      console.error('Search failed:', error);
      setSearchResults([]);
      setSearchTime(0);
    },
  });

  const testSearchQuery = useQuery({
    queryKey: ['test-search'],
    queryFn: () => searchAPI.testSearch(),
    enabled: false, // Don't run automatically
  });

  return {
    search: searchMutation.mutate,
    searchResults,
    searchTime,
    isSearching: searchMutation.isPending,
    searchError: searchMutation.error,
    
    // Test search
    runTestSearch: testSearchQuery.refetch,
    testResults: testSearchQuery.data?.data?.matches || [],
    isTestLoading: testSearchQuery.isFetching,
    testError: testSearchQuery.error,
  };
}
